module.exports = __webpack_public_path__ + "files/a12841dae33d2f5b5444bc09d4794a8a.png";